import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const MobileBottomNav = () => {
    const location = useLocation();

    const navItems = [
        { icon: '🏠', label: 'Home', path: '/admin/dashboard' },
        { icon: '🧾', label: 'Bills', path: '/billing/history' },
        { icon: '💍', label: 'Jewellery', path: '/jewellery/list' },
        { icon: '👤', label: 'Customers', path: '/customers' }
    ];

    return (
        <div className="mobile-bottom-nav" style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            width: '100%',
            backgroundColor: 'var(--white)',
            boxShadow: '0 -2px 10px rgba(0,0,0,0.05)',
            display: 'flex',
            justifyContent: 'space-around',
            padding: '8px 0',
            zIndex: 1000,
            borderTop: '1px solid rgba(0,0,0,0.05)'
        }}>
            {navItems.map((item, index) => {
                const isActive = location.pathname === item.path;
                return (
                    <Link key={index} to={item.path} style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textDecoration: 'none',
                        color: isActive ? 'var(--gold-primary)' : 'var(--text-secondary)',
                        fontSize: '11px',
                        fontWeight: '500',
                        gap: '4px',
                        width: '25%'
                    }}>
                        <span style={{ fontSize: '20px', filter: isActive ? 'none' : 'grayscale(100%) opacity(0.7)' }}>{item.icon}</span>
                        <span>{item.label}</span>
                    </Link>
                );
            })}
        </div>
    );
};

export default MobileBottomNav;
